import { Link, useNavigate, useParams, Navigate } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { useState, useEffect } from "react";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import Preloading from "../../../components/basics/Preloading";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import emptyMenu from "../../../assets/images/img/emptyMenu.svg";
import Paginations from "../../../components/paginaton/Paginations";

const MenuCategoryManage = () => {
  let { unitId } = useParams("unitId");
  let { branchId } = useParams("branchId");
  let { parentId } = useParams("parentId");
  const [parent, setParent] = useState({
    id: 0,
    title: "",
    parentId: 0,
    // saleUnitId: 0,
    saleUnitId: unitId,
  });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [totalPages, setTotalPages] = useState("");
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    parentId: parentId,
    size: 20,
    part: 1,
    title: "",
    enabled: true,
    // saleUnitId: 0,
    saleUnitId: unitId,
    total: 0,
    parts: 0,
  });
  const [gridData, setGridData] = useState([]);
  const [saleUnits, setSaleUnits] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [isImageUploading, setIsImageUploading] = useState(false);
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    imgSrc: "",
    logo: "",
    tels: "",
    description: "",
    ordering: "",
    branchId: branchId,
    parentTitle: "",
    childCount: "",
    menuCount: "",
    snappItem: false,
    saleUnitId: unitId,
    parentId: parentId,
  });
  const [pageTitle, setPageTitle] = useState("");
  const [unitTitle, setUnitTitle] = useState("");

  const mapParent = (model) => {
    parent.id = model.id;
    parent.title = model.title;
    parent.parentId = model.parentId === null ? 0 : model.parentId;
    parent.saleUnitId = model.saleUnitId;
    setParent({ ...parent });
  };

  const getParentItem = async (id) => {
    const resp = await apiMethod.getMenuCategoryInfo(id);
    if (methods.showApiErrors(resp)) {
      mapParent(resp.data);
    }
    setPageTitle(resp.data.title);
  };

  const getGirdData = async (customEnabled) => {
    const enabled = customEnabled ?? filterModel.enabled;
    const resp = await apiMethod.getMenuCategories(
      filterModel.branchId,
      filterModel.parentId,
      filterModel.size,
      filterModel.part,
      filterModel.title,
      filterModel.saleUnitId,
      enabled
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      setTotalPages(resp.total);
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
      setUnitTitle(resp.saleUnitInfo.title);
    }
  };

  const getPageTitle = async () => {
    const response = await apiMethod.getUnitInfo(unitId);
    if (!methods.showApiErrors(response)) return false;

    setUnitTitle(response.data.title);
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGirdData(true);
    setLoading(false);
  };

  const getBaseInfo = async () => {
    const resp = await apiMethod.getAllUnits(filterModel.branchId);
    if (methods.showApiErrors(resp)) setSaleUnits(resp.data);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGirdData(true);
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getBaseInfo();
    getPageTitle();
    if (parentId > 0) getParentItem(parentId);
    getGirdData(true);
    setLoading(false);
  }, [branchId, parentId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push(".عنوان باید مقدار داشته باشد");
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    const resetValues = {
      id: 0,
      title: "",
      imgSrc: "",
      logo: "",
      tels: "",
      description: "",
      branchId: branchId,
      createBy: "",
      createDate: "",
      modifyBy: "",
      modifyDate: "",
      parentId: parentId,
      parentTitle: "",
      childCount: "",
      menuCount: "",
      snappItem: false,
      // saleUnitId: formModel.parentId === "0" ? 0 : formModel.saleUnitId,
      saleUnitId: unitId,
    };

    setFormModel({ ...resetValues });
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.parentId = parentId;
    filterModel.size = 20;
    filterModel.part = 1;
    filterModel.title = "";
    filterModel.saleUnitId = unitId;
    filterModel.enabled = "";
    setFilterModel({ ...filterModel });
  };

  const editItem = async (id) => {
    try {
      const response = await apiMethod.getMenuCategoryInfo(id);
      if (response.status === 200) {
        const menuCategoryUnitInfo = response.data;
        setFormModel((prevData) => ({
          ...prevData,
          ...menuCategoryUnitInfo,
        }));
        setShowModal(true);
      } else {
        methods.showErrors(response.messages);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const createNewItem = async (e) => {
    if (!validForm()) return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createMenuCategory(formModel);
      if (!methods.showApiErrors(resp)) return false;

      await getGirdData(true);
      setShowModal(false);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
    return true;
  };

  const changeSaleUnit = (e) => {
    const selectedSaleUnitId = e.target.value;
    setFormModel((prevData) => ({
      ...prevData,
      saleUnitId: selectedSaleUnitId,
    }));
  };

  const UploadFile = async (file, attributeName) => {
    try {
      const formData = new FormData();
      formData.append("File", file);
      formData.append("FileType", 1);

      // Check if the attribute name is "imgSrc" or "logo" and append the corresponding value to the FormData
      const attributeValue = formModel[attributeName];
      if (typeof attributeValue === "string") {
        formData.append(attributeName, attributeValue);
      }
      const response = await apiMethod.uploadFile(formData);

      // Update branchData with the response data
      setFormModel((prevData) => ({
        ...prevData,
        [attributeName]: response.data,
      }));
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const changeImage = (fileOrEvent) => {
    let file;
    if (fileOrEvent instanceof File) {
      file = fileOrEvent;
    } else {
      file = fileOrEvent.target.files[0];
    }

    setFormModel((prevData) => ({
      ...prevData,
      imgSrc: file,
    }));
    setIsImageUploading(true);

    // Upload the file
    UploadFile(file, "imgSrc")
      .then(() => {
        // Stop the loading state when the file is uploaded
        setIsImageUploading(false);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
  };

  const backToTopLevel = async () => {
    if (parentId == 0) navigate(`/sale/${branchId}/selectUnit`);
    else {
      setLoading(true);
      let topParentId = parent.parentId > 0 ? parent.parentId : 0;
      parentId = parent.parentId;
      if (parent.parentId > 0) await getParentItem(parent.parentId);
      else {
        mapParent({
          id: 0,
          title: "",
          parentId: 0,
          saleUnitId: unitId,
        });
      }
      setPageInfo();
      await getGirdData(true);
      setLoading(false);
      navigate(`/sale/${branchId}/${unitId}/menuCategoryManage/${topParentId}`);
    }
  };

  const setPageInfo = () => {
    formModel.parentId = parentId;
    formModel.saleUnitId = parent.saleUnitId;
    setFormModel({ ...formModel });
    filterModel.parentId = parentId;
    filterModel.saleUnitId = parent.saleUnitId;
    setFilterModel({ ...filterModel });
  };

  const goToSubCategories = async (item) => {
    setLoading(true);
    mapParent(item);
    parentId = item.id;
    setPageInfo();
    navigate(`/sale/${branchId}/${unitId}/menuCategoryManage/${item.id}`);
    await getGirdData(true);
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGirdData("");
    setLoading(false);
  };

  const handleSwitchChange = async (id) => {
    setLoading(true);
    const resp = await apiMethod.enableMenuCategory(id);
    if (!methods.showApiErrors(resp)) return false;
    setLoading(false);
    await getGirdData(true);
  };

  const closeModal = () => {
    resetForm();
    setShowModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const openNewForm = () => {
    resetForm();
    setShowModal(true);
    setFormModel((prevState) => ({
      ...prevState,
      enabled: true,
    }));
  };

  const selectَItemToDelete = (item) => {
    setFormModel(item);
    setShowDeleteModal(true);
  };

  const deleteItem = async (id) => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeMenuCategory(formModel.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGirdData(true);
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const handleActive = async () => {
    setLoading(true);
    await getGirdData(true);
    setLoading(false);
  };

  const handleDeActive = async () => {
    setLoading(true);
    await getGirdData(false);
    setLoading(false);
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-flex justify-content-start align-items-baseline mb-3">
              <Link
                className="link back-link"
                to={
                  parentId == 0
                    ? `/sale/${branchId}/selectUnit`
                    : `/sale/${branchId}/${unitId}/menuCategoryManage/${
                        parent.parentId > 0 ? parent.parentId : 0
                      }`
                }
                onClick={(e) => {
                  if (e.button === 0 && !e.ctrlKey && !e.metaKey) {
                    e.preventDefault();
                    backToTopLevel();
                  }
                }}
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  className="link back-link"
                  to={
                    parentId == 0
                      ? `/sale/${branchId}/selectUnit`
                      : `/sale/${branchId}/${unitId}/menuCategoryManage/${
                          parent.parentId > 0 ? parent.parentId : 0
                        }`
                  }
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                منوهای فروش /دسته‌بندی‌ها
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                منوهای فروش / {unitTitle} / دسته‌بندی‌ها
                <a
                  href={`/sale/${branchId}/softwareGuide/#section5`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            {parentId === "0" ? (
              <p className="saleheader text-start">دسته‌بندی‌ها</p>
            ) : (
              <p className="saleheader text-start">دسته‌بندی‌های {pageTitle}</p>
            )}
            <div className="salemain">
              <div className="salesearchsection">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-4">
                    <label htmlFor="funit" className="form-label">
                      عنوان
                    </label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: "rtl", textAlign: "right" }}
                        value={filterModel.title}
                        onChange={(e) => {
                          setFilterModel({
                            ...filterModel,
                            title: e.target.value,
                            part: 1,
                          });
                        }}
                      />
                      <button
                        type="button"
                        className="btn btn-purple me-1"
                        onClick={() => {
                          searchItem();
                        }}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-info"
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-12 col-md-2 col-lg-3"></div>
                  <div className="col-12 col-md-4 col-lg-5">
                    <div className="d-flex align-items-center justify-content-end gap-3">
                      <div
                        className="d-flex align-items-center gap-2"
                        style={{ marginTop: "26px" }}
                      >
                        <button
                          className="btn btn-purple"
                          style={{ height: "48px" }}
                          onClick={handleActive}
                        >
                          دسته بندی های فعال
                        </button>
                        <button
                          className="btn btn-purple"
                          style={{ height: "48px" }}
                          onClick={handleDeActive}
                        >
                          دسته بندی های غیر فعال
                        </button>
                      </div>
                      <div className="createButton">
                        <button
                          onClick={() => {
                            openNewForm();
                          }}
                          className="btn btn-outline-purple custome-btn"
                          type="button"
                        >
                          <span className="align-middle d-inline-block">
                            دسته‌بندی جدید
                          </span>{" "}
                          <i className="bi bi-plus-circle align-middle"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="table-responsive saletable position-relative">
                {saleUnits.length === 0 ? (
                  <div className="my-5">
                    <div>
                      <span>
                        ابتدا اطلاعات مربوط به این بخش باید تکمیل شود.{" "}
                      </span>
                      <button
                        className="btn btn-outline-purple"
                        onClick={() => {
                          navigate(`/sale/${branchId}/saleunits`);
                        }}
                      >
                        افزودن بخش فروش
                      </button>
                    </div>
                  </div>
                ) : (
                  gridData.length === 0 && (
                    <div className="">
                      <div>
                        <img src={emptyMenu} alt="noItem" />
                      </div>
                      <p>هیچ دسته‌ای تا کنون ثبت نشده است.</p>
                    </div>
                  )
                )}
                <div className="row row-cols-1 row-cols-md-3 g-4">
                  {gridData.map((item, index) => (
                    <div className="col" key={index}>
                      <div className="card h-100">
                        <div className="card-body">
                          <div
                            className="branchCardImg mb-3"
                            style={{
                              backgroundImage: `url(${methods.normalImage(
                                item.imgSrc,
                                "menu"
                              )})`,
                            }}
                          ></div>
                          <p className="menutitle">{item.title}</p>
                          <p className="fs-6 text-secondary">
                            {item.unitTitle}
                          </p>
                          <hr className="mb-3" />
                          {item.allowToCreateSub ? (
                            <button
                              type="button"
                              className="btn custome-btn btn-outline-purple w-100"
                              onClick={() => {
                                goToSubCategories(item);
                              }}
                            >
                              زیردسته‌ها
                              <span className="badge sidebar-badge rounded-pill ms-1">
                                {item.childCount}
                              </span>
                            </button>
                          ) : (
                            <div className="btn custome-btn"></div>
                          )}
                          {item.allowToCreateMenu ? (
                            <button
                              type="button"
                              className="btn custome-btn btn-outline-purple w-100 my-2"
                              onClick={() =>
                                navigate(
                                  `/sale/${branchId}/${unitId}/menuCategoryManage/menu/${item.id}`
                                )
                              }
                            >
                              منوها
                              <span className="badge sidebar-badge rounded-pill ms-1">
                                {item.menuCount}
                              </span>
                            </button>
                          ) : (
                            <div className="btn custome-btn my-2"></div>
                          )}
                          <div className="d-flex align-items-center justify-content-between my-3">
                            <span>وضعیت</span>
                            <div className="d-flex align-items-center gap-2">
                              {item.enabled === true ? "فعال" : "غیرفعال"}
                              <div
                                className="form-check form-switch purple-switch"
                                style={{ paddingLeft: "0" }}
                              >
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  checked={item.enabled}
                                  onChange={() => handleSwitchChange(item.id)}
                                  id="switchCheckChecked"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="d-flex align-items-center justify-content-center border p-2 rounded">
                            <span> ثبت اسنپ</span>
                            <input
                              type="checkbox"
                              // checked={serviceData?.isTaxFree}
                              // onChange={() => taxCheckboxChange()}
                              className="pagercheckbox me-2"
                            />
                          </div>
                          <hr className="mb-0" />
                        </div>
                        <div className="d-flex justify-content-between align-items-center mx-2 mb-1 mt-0">
                          <button
                            type="submit"
                            className="btn custome-btn CardDeleteBtn"
                            onClick={() => selectَItemToDelete(item)}
                          >
                            حذف
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-trash"
                              viewBox="0 0 16 16"
                            >
                              <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                              <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                            </svg>
                          </button>
                          <button
                            type="submit"
                            className="btn custome-btn btn-link-green"
                            onClick={() => editItem(item.id)}
                          >
                            ویرایش
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              className="bi bi-pencil-square"
                              viewBox="0 0 16 16"
                            >
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div style={{ right: "95%" }} className="pushData">
                  <button
                    type="button"
                    className="btn btn-lg btn-purple rounded-circle position-relative"
                    onClick={() => {
                      openNewForm();
                    }}
                  >
                    <i className="bi bi-file-earmark-plus"></i>
                  </button>
                </div>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={totalPages}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  const Modal = () => {
    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title"> ایجاد / ویرایش دسته‌بندی</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    value={formModel.title}
                    onChange={(e) =>
                      setFormModel((prevData) => ({
                        ...prevData,
                        title: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="ordering"
                    className="form-label required-label"
                  >
                    ترتیب نمایش
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="ordering"
                    name="ordering"
                    value={formModel.ordering}
                    onChange={(e) =>
                      setFormModel((prevData) => ({
                        ...prevData,
                        ordering: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="col-md-12">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={formModel.enabled}
                      onChange={(e) =>
                        setFormModel((prevData) => ({
                          ...prevData,
                          enabled: e.target.checked,
                        }))
                      }
                      id="switchCheckChecked"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="switchCheckChecked"
                    >
                      وضعیت
                    </label>
                  </div>
                </div>
                {/* {(formModel.parentId === "0") ?
                  < div className="col-md-12">
                    <label htmlFor="unitTitle" className="form-label required-label">بخش فروش</label>
                    <select
                      id="saleUnit"
                      className="form-select"
                      aria-label="Default select example"
                      value={formModel.saleUnitId}
                      onChange={changeSaleUnit}
                    >
                      <option value="">همه‌ی بخش‌ها </option>
                      {saleUnits.map((saleUnit) => (
                        <option key={saleUnit.id} value={saleUnit.id}>
                          {saleUnit.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  : <div></div>
                } */}
                <div className="col-md-12">
                  <label htmlFor="description" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    value={formModel.description}
                    onChange={(e) =>
                      setFormModel((prevData) => ({
                        ...prevData,
                        description: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="col-md-12 my-4">
                  <label htmlFor="fileUpload" className="form-label">
                    انتخاب تصویر <br></br>
                    <span style={{ fontSize: "14px" }}>
                      (اندازه استاندارد 600×900 و حداکثر حجم 600kb است.)
                    </span>
                  </label>
                  <div
                    className="uploadfile"
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      const file = e.dataTransfer.files[0];
                      changeImage(file);
                    }}
                  >
                    {!isImageUploading && (
                      <label htmlFor="imagefileInput">
                        {formModel.imgSrc
                          ? formModel.imgSrc
                          : "تصویر را بکشید اینجا بیاندازید"}
                        <input
                          type="file"
                          id="imagefileInput"
                          style={{ display: "none" }}
                          name="imagefileInput"
                          accept=".jpg, .jpeg, .png"
                          onChange={(e) => changeImage(e.target.files[0])}
                        />
                      </label>
                    )}
                    {isImageUploading && (
                      <div className="uploadfileloading form-control border-0">
                        <span
                          className="spinner-border spinner-border-sm"
                          aria-hidden="true"
                        ></span>
                        <span role="status"> در حال بارگذاری ... </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              {isImageUploading ? (
                <button
                  type="submit"
                  className="btn custome-btn btn-purple w-50"
                  disabled
                >
                  ثبت وذخیره
                </button>
              ) : (
                <button
                  onClick={() => {
                    createNewItem();
                  }}
                  type="submit"
                  className="btn custome-btn btn-purple w-50"
                >
                  ثبت وذخیره
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={"دسته‌بندی"}
        />
      )}
    </>
  );
};

export default MenuCategoryManage;
